import wujiFetch from '@utils/wujiFetch';
import { BASE_API_PATH } from '@/config/constant';
import { getDefaultProjectSettings } from '@loaders/project/utils';
class ProjectSettingService {
    /**
     * 获取项目设置（原始数据）
     */
    async fetch(projectId) {
        return await wujiFetch(`${BASE_API_PATH}/xy/setting?projectid=${projectId}`);
    }
    /**
     * 获取项目设置（带默认值合并）
     */
    async fetchWithDefaults(projectId) {
        const data = await this.fetch(projectId);
        const defaultSetting = getDefaultProjectSettings();
        return {
            ...(defaultSetting ?? {}),
            ...(data ?? {}),
            versionSetting: {
                ...(defaultSetting?.versionSetting ?? {}),
                ...(data?.versionSetting ?? {}),
            },
            permissionSetting: {
                ...(defaultSetting?.permissionSetting ?? {}),
                ...(data?.permissionSetting ?? {}),
            },
            aiBackendSetting: {
                ...(defaultSetting?.aiBackendSetting ?? {}),
                ...(data?.aiBackendSetting ?? {}),
            },
            aiDeploySetting: {
                ...(defaultSetting?.aiDeploySetting ?? {}),
                ...(data?.aiDeploySetting ?? {}),
            },
        };
    }
    /**
     * 保存项目设置
     */
    async save(projectId, data) {
        await wujiFetch(`${BASE_API_PATH}/xy/setting?projectid=${projectId}`, {
            method: 'POST',
            body: JSON.stringify(data),
        });
    }
    /**
     * 获取机器人配置列表（原始数据）
     */
    async fetchRobotList(projectId) {
        const settings = await this.fetch(projectId);
        return settings?.robots || [];
    }
}
export const projectSettingService = new ProjectSettingService();
export default {
    fetch: (projectId) => projectSettingService.fetch(projectId),
    fetchWithDefaults: (projectId) => projectSettingService.fetchWithDefaults(projectId),
    save: (projectId, data) => projectSettingService.save(projectId, data),
    fetchRobotList: (projectId) => projectSettingService.fetchRobotList(projectId),
};
